var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1_7)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 27,
    r: 24,
    fill: "#E58278"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 21.4825C37.0808 20.9146 37.0808 19.9938 36.5 19.4259C35.9192 18.858 34.9776 18.858 34.3968 19.4259C14.9964 38.3962 18.1569 39.4189 36.5 21.4825Z",
    fill: "#FAF9F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 21.4825C37.0808 20.9146 37.0808 19.9938 36.5 19.4259C35.9192 18.858 34.9776 18.858 34.3968 19.4259C14.9964 38.3962 18.1569 39.4189 36.5 21.4825Z",
    fill: "#FAF9F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9356 32.5C20.3548 33.0679 20.3548 33.9887 20.9356 34.5566C21.5164 35.1245 22.458 35.1245 23.0388 34.5566C42.4392 15.5863 39.2787 14.5637 20.9356 32.5Z",
    fill: "#FAF9F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9356 32.5C20.3548 33.0679 20.3548 33.9887 20.9356 34.5566C21.5164 35.1245 22.458 35.1245 23.0388 34.5566C42.4392 15.5863 39.2787 14.5637 20.9356 32.5Z",
    fill: "#FAF9F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1245 32.5175C36.7053 33.0854 36.7053 34.0062 36.1245 34.5741C35.5438 35.142 34.6021 35.142 34.0213 34.5741C14.6209 15.6038 17.7815 14.5811 36.1245 32.5175Z",
    fill: "#FAF9F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1245 32.5175C36.7053 33.0854 36.7053 34.0062 36.1245 34.5741C35.5438 35.142 34.6021 35.142 34.0213 34.5741C14.6209 15.6038 17.7815 14.5811 36.1245 32.5175Z",
    fill: "#FAF9F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5171 21.4825C19.9363 20.9146 19.9363 19.9938 20.5171 19.4259C21.0979 18.858 22.0396 18.858 22.6203 19.4259C42.0208 38.3962 38.8602 39.4189 20.5171 21.4825Z",
    fill: "#FAF9F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5171 21.4825C19.9363 20.9146 19.9363 19.9938 20.5171 19.4259C21.0979 18.858 22.0396 18.858 22.6203 19.4259C42.0208 38.3962 38.8602 39.4189 20.5171 21.4825Z",
    fill: "#FAF9F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1_7",
    x: 0.4,
    y: 0.3,
    width: 55.2,
    height: 55.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.225
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.45
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_7",
    result: "effect2_dropShadow_1_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_7",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b81be96144a4161ace094317d802c1c0.svg";
export { ForwardRef as ReactComponent };